import React, { Component } from 'react';
import ClientService from '../../../Services/clientService';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ClientItem from '../../../Domain/ClientItem';
import ButtonRow from '../../../Elements/ButtonRow';
import ClientSearchParams from './ClientSearchParams';
import ClientSassieWindowDescription from './ClientSassieWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditClientWindowDescription from './EditClientWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import EditClientInvoiceWindowDescription from '../../Operations/ClientInvoiceAdmin/EditClientInvoiceWindowDescription';
import ClientInvoiceAdminItem from '../../../Domain/ClientInvoiceAdminItem';
import contactService from '../../../Services/contactService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ProjectAssignmentService from '../../../Services/ProjectAssignmentsService';
import CreateClientPaymentItem from '../../../Domain/CreateClientPaymentItem.ts';
import CreateClientPaymentWindowDescription from '../../Finance/ClientPayment/CreateClientPaymentWindowDescription';
import AddParentWindowDescription from './AddParentWindowDescription';
import AddExternalQuestionaireWindowDescription from './AddExternalQuestionaireWindowDescription';
import OfficeService from '../../../Services/OfficeService';
import TpClientInvoiceItem from '../../../Domain/TpClientInvoiceItem';
import ClientInvoiceFormOptionsArray from '../../../Enums/ClientInvoiceFormOptionsArray';
import EditTpClientInvoiceWindowDescription from '../../Operations/TpClientInvoice/EditTpClientInvoiceWindowDescription';
import CreateTpClientPaymentItem from '../../../Domain/CreateTpClientPaymentItem.js';
import CreateTpClientPaymentWindowDescription from '../../ThirdParty/TpClientPayment/CreateTpClientPaymentWindowDescription';

export default class ClientAdmin extends Component {
  constructor(props) {
    super(props);

    const newSearchItem = new ClientSearchParams(props.IsSubClientsView);
    if (props.ParentId) {
      newSearchItem.ParentId = props.ParentId;
      newSearchItem.OfficeId = '';
      newSearchItem.IsSubClientsView = true;
    }

    // Deep-link seed for global record search (CD-5425), following the ClientInvoiceAdmin.js:31
    // pattern. content.js renders a deep-linked page with no props, so the URL is the only channel.
    const seededName = new URLSearchParams(window.location.search).get('Name');
    if (seededName) {
      newSearchItem.Name = seededName;
      // Clear the office filter, which otherwise defaults to the logged-in user's own office. The
      // palette applies no office scoping, so a hit from another office would arrive here and be
      // filtered straight back out - the user would click a result and land on an empty grid.
      newSearchItem.OfficeId = '';
    }

    this.state = {
      searchItem: newSearchItem,
      shownPanel: ShownPanelsEnum.None,
      selectedItem: null,
    };

    this.bindFunctions();
    this.handleButtonRowButtonClick = this.handleButtonRowButtonClick.bind(this);
    this.refresh = this.refresh.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    ClientItem.editFunction = this.clickOnEditIcon.bind(this);
    ClientItem.sassieeditFunction = this.sassieeditFunction.bind(this);
    ClientItem.createInvoiceFunction = this.createInvoiceFunction.bind(this);
    ClientItem.createInvoiceNewFunction = this.createInvoiceNewFunction.bind(this);
    ClientItem.createPaymentFunction = this.createPaymentFunction.bind(this);
    ClientItem.createTpPaymentFunction = this.createTpPaymentFunction.bind(this);
    ClientItem.addExternalQuestionaireFunction = this.addExternalQuestionaireFunction.bind(this);
  }

  sassieeditFunction(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.EditSubItem,
    });
  }

  clickOnEditIcon(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  createInvoiceFunction(selectedId, selectedItem) {
    const clientInvoice = new ClientInvoiceAdminItem();
    clientInvoice.CiCcid = selectedItem.ClientId;
    clientInvoice.ClientName = selectedItem.Name;
    clientInvoice.OfficeName = selectedItem.OfficeName;
    clientInvoice.CiOfficeId = selectedItem.OfficeId;
    clientInvoice.CiDaysToPay = selectedItem.DaysToPayCode ? selectedItem.DaysToPayCode : 30;
    clientInvoice.CiInterestRate = selectedItem.InvoiceInterestRate ? selectedItem.InvoiceInterestRate : 0;
    clientInvoice.GenerationType = 'New';
    if (clientInvoice.CiOfficeId === 9)
      clientInvoice.FulfillmentDate = dateTimeHelper.addDaysToDate(dateTimeHelper.toYYYYsMMsDD(new Date()), 1);

    contactService
      .GetContactListByClientId(selectedItem.ClientId, true)
      .then((contacts) => {
        clientInvoice.ClientContacts = contacts;

        ProjectAssignmentService.GetProjectAssignmentAdditionalInformation(selectedItem.ClientId)
          .then((result) => {
            const defaultReportName = EditClientInvoiceWindowDescription.getInvoiceFormOptions().find(
              (f) => f.label === result.ciDefaultReportName
            );
            clientInvoice.CiDefaultReportName = defaultReportName ? defaultReportName.value : '';
            clientInvoice.CiRcyid = result.billingCurId;

            this.setState({
              selectedItem: clientInvoice,
              shownPanel: ShownPanelsEnum.AddNewSubItem,
            });
          })
          .catch((error) => ErrorMessage.SetErrorMessage('CA75', error));
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CA77', error));
  }

  createInvoiceNewFunction(selectedId, selectedItem) {
    const clientInvoice = new TpClientInvoiceItem();
    clientInvoice.CaspianClientId = selectedItem.ClientId;
    clientInvoice.CaspianClientName = selectedItem.Name;
    clientInvoice.OfficeName = selectedItem.OfficeName;
    clientInvoice.OfficeId = selectedItem.OfficeId;
    clientInvoice.DaysToPay = selectedItem.DaysToPayCode ? selectedItem.DaysToPayCode : 30;
    clientInvoice.LatePaymentInterestRate = selectedItem.InvoiceInterestRate ? selectedItem.InvoiceInterestRate : 0;
    if (clientInvoice.OfficeId === 9)
      clientInvoice.FulfillmentDate = dateTimeHelper.addDaysToDate(dateTimeHelper.toYYYYsMMsDD(new Date()), 2);

    contactService
      .GetContactListByClientId(selectedItem.ClientId, true)
      .then((contacts) => {
        clientInvoice.ClientContacts = contacts;

        ProjectAssignmentService.GetProjectAssignmentAdditionalInformation(selectedItem.ClientId)
          .then((result) => {
            clientInvoice.DefaultReportName = ClientInvoiceFormOptionsArray.find(
              (f) => f.label === result.ciDefaultReportName
            ).value;
            clientInvoice.CurrencyId = result.billingCurId;

            this.setState({
              selectedItem: clientInvoice,
              shownPanel: ShownPanelsEnum.AddNewInvoice,
            });
          })
          .catch((error) => ErrorMessage.SetErrorMessage('CA134', error));
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CA146', error));
  }

  createPaymentFunction(selectedId, selectedItem) {
    const clientPayment = new CreateClientPaymentItem();
    clientPayment.CpCcid = selectedItem.ClientId;
    clientPayment.CpReceivingOfficeId = selectedItem.OfficeId;
    clientPayment.staticClient = selectedItem.ClientId;

    OfficeService.GetOfficeBillingCurrency(selectedItem.OfficeId)
      .then((currency) => {
        if (!currency) {
          ErrorMessage.SetErrorMessage('No billing currency found for the office');
          return;
        }
        clientPayment.CpRcyid = currency.currencyId;
        this.setState({
          selectedItem: clientPayment,
          shownPanel: ShownPanelsEnum.AddNewPayment,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CA156', error));
  }

  createTpPaymentFunction(selectedId, selectedItem) {
    const clientPayment = new CreateTpClientPaymentItem();
    clientPayment.ClientId = selectedItem.ClientId;
    clientPayment.ReceivingOfficeId = selectedItem.OfficeId;

    OfficeService.GetOfficeBillingCurrency(selectedItem.OfficeId)
      .then((currency) => {
        if (!currency) {
          ErrorMessage.SetErrorMessage('No billing currency found for the office');
          return;
        }
        clientPayment.CurrencyId = currency.currencyId;
        this.setState({
          selectedItem: clientPayment,
          shownPanel: ShownPanelsEnum.AddNewTpPayment,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CA156', error));
  }

  addParentFunction(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.AddNewParent,
    });
  }

  addExternalQuestionaireFunction(selectedId, selectedItem) {
    selectedItem.InfoText =
      'This will add an external questionnaire for the client to collect the following information: TestField1, TestField2.';
    selectedItem.EntityId = selectedItem.ClientId;
    selectedItem.EntityType = 'Client';
    selectedItem.TemplateName = 'Client Form Template';
    selectedItem.ThanksTemplateName = 'Client Thank You Template';
    selectedItem.SubmittedTemplateName = 'Client Submitted Template';
    selectedItem.EnableMultipleResponses = false;

    selectedItem.ExpirationDate = dateTimeHelper.addHoursToDate(new Date(), 36);
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.AddExternalQuestionaire,
    });
  }

  removeParentFunction(selectedId, selectedItem) {
    ErrorMessage.SetApprove(
      <span>
        You will remove the parent from this client.
        <br />
        Are you sure?
      </span>,
      () => this.handleRemoveParent(selectedId)
    );
  }

  handleRemoveParent(selectedId) {
    ClientService.RemoveParent(selectedId)
      .then((result) => {
        if (result?.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        ErrorMessage.SetSuccess('Parent removed successfully.');
        this.refresh();
      })
      .catch(() => ErrorMessage.SetErrorMessage('CA127'));
  }

  refresh() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  handleButtonRowButtonClick(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  handleExportExcelButtonClick() {
    ClientService.ExportAdminExcelAsync(this.state.searchItem).catch(() => ErrorMessage.SetErrorMessage('CA109'));
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderButtonsAndPanels() {
    return (
      <>
        {!this.props.IsSubClientsView && (
          <ButtonRow
            labels={['Create']}
            colors={[ButtonColorsEnum.Primary]}
            keys={[ShownPanelsEnum.AddNewItem]}
            icons={['fa-solid fa-plus-circle']}
            roleKeys={['Client_ButtonRowButton_Create']}
            value={this.state.shownPanel}
            onClick={this.handleButtonRowButtonClick}
            tooltips={['Create a new Client']}
          />
        )}
        {this.renderPanels()}
      </>
    );
  }

  renderAddNewItemPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.AddNewItem,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={new ClientItem()}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={EditClientWindowDescription}
        errorCode={'CA112'}
      />
    );
  }

  renderEditPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.EditItem,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={this.state.selectedItem}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={EditClientWindowDescription}
        errorCode={'CA123'}
      />
    );
  }

  renderClientSassieAdminPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.EditSubItem,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={{ ...this.state.selectedItem, ConfirmMismatch: false }}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        windowDescription={ClientSassieWindowDescription}
        errorCode='CLI-SASSIE'
      />
    );
  }

  renderEditClientInvoiceWindowPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.AddNewSubItem,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={this.state.selectedItem}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={EditClientInvoiceWindowDescription}
        errorCode={'CA141'}
      />
    );
  }

  renderEditClientInvoiceNewWindowPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.AddNewInvoice,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={this.state.selectedItem}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={EditTpClientInvoiceWindowDescription}
        errorCode={'CA141'}
      />
    );
  }

  renderCreateClientPaymentWindowPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.AddNewPayment,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={this.state.selectedItem}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={CreateClientPaymentWindowDescription}
        errorCode={'CA192'}
      />
    );
  }

  renderCreateTpClientPaymentWindowPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.AddNewTpPayment,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={this.state.selectedItem}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={CreateTpClientPaymentWindowDescription}
        errorCode={'CA334'}
      />
    );
  }

  renderAddParentWindowPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.AddNewParent,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={this.state.selectedItem}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={AddParentWindowDescription}
        errorCode={'CA248'}
      />
    );
  }

  renderAddExternalQuestionaireWindowPanel() {
    return this.renderOnePanel(
      ShownPanelsEnum.AddExternalQuestionaire,
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={this.state.selectedItem}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnSave={this.refresh}
        windowDescription={AddExternalQuestionaireWindowDescription}
        errorCode={'CA260'}
      />
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderAddNewItemPanel()}
        {this.renderEditPanel()}
        {this.renderClientSassieAdminPanel()}
        {this.renderEditClientInvoiceWindowPanel()}
        {this.renderEditClientInvoiceNewWindowPanel()}
        {this.renderCreateClientPaymentWindowPanel()}
        {this.renderCreateTpClientPaymentWindowPanel()}
        {this.renderAddParentWindowPanel()}
        {this.renderAddExternalQuestionaireWindowPanel()}
      </div>
    );
  }

  bindFunctions() {
    this.handleButtonRowButtonClick = this.handleButtonRowButtonClick.bind(this);
    this.refresh = this.refresh.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    ClientItem.editFunction = this.clickOnEditIcon.bind(this);
    ClientItem.sassieeditFunction = this.sassieeditFunction.bind(this);
    ClientItem.createInvoiceFunction = this.createInvoiceFunction.bind(this);
    ClientItem.createPaymentFunction = this.createPaymentFunction.bind(this);
    ClientItem.addParentFunction = this.addParentFunction.bind(this);
    ClientItem.removeParentFunction = this.removeParentFunction.bind(this);
    ClientItem.addExternalQuestionaireFunction = this.addExternalQuestionaireFunction.bind(this);
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ClientItem}
          serviceFunction={ClientService.GetClientItemListWithInvoiceAutomation}
          convertDBItemsFunction={ClientService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={ClientSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={(searchItem) => this.handleClickOnStartSearch(searchItem)}
          singleSearchLine={true}
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='reports_clientexport'
          singleSearchLinePlaceholder='Search in Client Id, Apollo Id or Client Name...'
          errorCode='CA120'
          afterClickOnCancel={() => this.bindFunctions()}
          enableUrlPush={!this.props.IsSubClientsView}
        />
      </div>
    );
  }

  handleClickOnStartSearch(searchItem) {
    if (this.props.IsSubClientsView) {
      searchItem.ParentId = this.props.ParentId;
      searchItem.OfficeId = '';
    }
    return this.setState({ searchItem });
  }
}
